/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import React from 'react';
import { Accordion, Button, Col, Row } from 'react-bootstrap';
import { FaCircleQuestion, FaRegFaceSadCry, FaWhatsapp, FaXmark } from 'react-icons/fa6';
import { help, store } from '@/helpers/index';

export default function HelpComponent({ state }) {
  const tab = store.get('manager-mix-tab');

  const categories = {
    GENERAL: 'Geral',
    PLATFORM: 'Plataforma',
    CRM: 'CRM',
    USER: 'Usuário',
    REPORT: 'Dúvidas da Consulta',
  };

  const getItems = () => {
    const result = [];
    if (tab && state.context === '/crm/mix-gerenciamento') {
      state.items.filter((el) => el.context === state.context && el.tab === tab).forEach((element) => {
        result.push(element);
      });
    }
    state.items.filter((el) => !el.tab && (!el.context || el.context === state.context)).forEach((element) => {
      if (!result.some((e) => e._id === element._id)) {
        result.push(element);
      }
    });
    return result;
  };

  const getGroup = () => {
    const result = {};
    const items = getItems();
    items.forEach((el) => {
      result[el.category] = [];
    });
    Object.keys(result).forEach((key) => {
      result[key] = items.filter((el) => el.category === key);
    });
    return result;
  };

  return (
    <div className="help overflow-x shadow-lg" id="help">
      {/* Header Bar */}
      <div className="d-flex justify-content-between align-items-start mb-4 pb-3 border-bottom">
        <div>
          <span className="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-1 fw-bold mb-1.5 d-inline-flex align-items-center gap-1">
            <FaCircleQuestion className="me-1" />
            Central de Ajuda
          </span>
          <h2 className="h4 fw-extrabold text-dark mb-0">Posso te ajudar?</h2>
          <span className="text-muted small">Tire suas dúvidas sobre termos e relatórios</span>
        </div>
        <Button
          variant="light"
          className="rounded-circle p-2 d-flex align-items-center justify-content-center border shadow-sm flex-shrink-0"
          onClick={() => help.close()}
          style={{ width: '38px', height: '38px' }}
          title="Fechar Ajuda"
        >
          <FaXmark className="fs-5 text-secondary" />
        </Button>
      </div>

      {/* Accordion FAQ Content */}
      {state.items?.length > 0 && getItems().length > 0 && (
        <div className="help-content mb-4">
          {Object.keys(getGroup()).map((group) => (
            <div className="mb-4" key={group}>
              {categories[group] && (
                <span className="badge bg-light text-secondary border rounded-pill px-3 py-1 fw-bold mb-3 d-inline-block">
                  {categories[group]}
                </span>
              )}
              <Accordion className="d-flex flex-column gap-2">
                {getGroup()[group].map((item) => (
                  <Accordion.Item eventKey={item._id} key={item._id} className="rounded-3 border shadow-sm overflow-hidden">
                    <Accordion.Header className="fw-bold text-dark">
                      {item.name}
                    </Accordion.Header>
                    <Accordion.Body className="bg-white text-secondary leading-relaxed">
                      <div dangerouslySetInnerHTML={{ __html: item.content }} />
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      )}

      {/* Empty State */}
      {getItems().length === 0 && (
        <div className="bg-light rounded-4 p-4 text-center my-5 border border-light-subtle">
          <FaRegFaceSadCry className="fs-1 text-muted mb-3" />
          <h5 className="fw-bold text-dark mb-1">Nenhuma ajuda disponível</h5>
          <p className="text-muted small mb-0">Não encontramos tópicos de ajuda específicos para esta página no momento.</p>
        </div>
      )}

      {/* Bottom Support CTA Card */}
      {/* <div className="bg-light rounded-4 p-4 border border-light-subtle mt-auto text-center">
        <h6 className="fw-bold text-dark mb-1">Ainda precisa de auxílio?</h6>
        <p className="text-muted small mb-3">Fale diretamente com um de nossos especialistas pelo WhatsApp.</p>
        <Button
          href="https://wa.me/5531998595585?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20um%20relat%C3%B3rio%20de%20consulta%20AboutCar"
          target="_blank"
          variant="success"
          className="btn-gradient-success rounded-pill px-4 py-2 fw-bold shadow-sm d-inline-flex align-items-center justify-content-center gap-2 w-100 border-0"
        >
          <FaWhatsapp className="fs-5" />
          <span>Falar no WhatsApp</span>
        </Button>
      </div> */}

      {/* Bottom Close Button for Mobile */}
      <div className="mt-3 text-center d-sm-none">
        <Button
          variant="outline-secondary"
          size="sm"
          className="rounded-pill px-4 py-2 fw-semibold w-100"
          onClick={() => help.close()}
        >
          <FaXmark className="me-1" />
          Fechar Central de Ajuda
        </Button>
      </div>
    </div>
  );
}
